<template>
  <div id="select_wrap">
    <div style="width: 100%">
      <Row>
        <Col span="24">
          <h3  @click="openSelectCar = true">
            <b>{{ $store.state.carMsg.carNo }}</b>
          </h3>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <Button
            type="text"
            v-for="(item, index) in dayList"
            :key="index"
            @click="selectGetDay(item.value)"
            >{{ item.label }}</Button
          >
        </Col>
      </Row>
      <Row>
        <Col span="5">开始时间</Col>
        <Col span="18" offset="1">
          <div class="input" @click="openPicker(0)">
            {{ utils.time(startTime) }}
          </div>
        </Col>
      </Row>
      <Row>
        <Col span="5">结束时间</Col>
        <Col span="18" offset="1">
          <div class="input" @click="openPicker(1)">
            {{ utils.time(endTime) }}
          </div>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <Button type="primary" long @click="history">立即查询</Button>
        </Col>
      </Row>
    </div>
    <Drawer
      title="选择车辆"
      width="100"
      :closable="true"
      v-model="openSelectCar"
    >
      <locate-tree @car="reCar" v-if="openSelectCar"></locate-tree>
    </Drawer>
    <mt-datetime-picker
      :startDate="new Date(2019, 12, 31)"
      :endDate="new Date(Date.now())"
      ref="picker0"
      type="datetime"
      v-model="startTime"
      @confirm="handleConfirm"
      class="lycol lycol5"
    ></mt-datetime-picker>
    <mt-datetime-picker
      :startDate="new Date(2019, 12, 31)"
      :endDate="new Date(Date.now())"
      ref="picker1"
      type="datetime"
      v-model="endTime"
      class="lycol lycol5"
    ></mt-datetime-picker>
  </div>
</template>
<script>
import locateTree from "../common/carTool.vue";
var selectDate; //点击哪个日期
export default {
  components: {
    locateTree,
  },
  data() {
    return {
      openSelectCar: false,
      playStatus: 1, //播放状态
      dayList: [
        {
          value: 0,
          label: "今天",
        },
        {
          value: 1,
          label: "昨天",
        },
        /* {
          value: 2,
          label: "前天",
        }, */
        {
          value: 3,
          label: "近三天",
        },
        {
          value: 7,
          label: "近七天",
        },
      ],
      day: 0,
      endDateOptions: {},
      ss: new Date(1577808000000),
      startTime: "",
      endTime: "",
      minTime: Date.now(),
      maxTime: Date.now() + 86400000,
    };
  },
  methods: {
    //点击查询按钮播放历史轨迹
    history() {
      if (
        this.$store.state.carMsg.deviceId.length == 0
        //时间只判断一个即可
      ) {
        this.$Message.error("请选择车辆");
        return;
      }
      this.$emit("history", { start: this.startTime, end: this.endTime });
    },
    //下拉快速选择日期
    selectGetDay(t) {
      var day = {
        200: { x: null, y: null },
        0: { x: 0, y: 0 },
        1: { x: -1, y: -1 },
        2: { x: -2, y: -2 },
        3: { x: -2, y: 0 },
        7: { x: -6, y: 0 },
      };
      var t1 = this.utils.days(day[t].x, day[t].y, false);

      this.startTime = new Date(t1.start);
      this.endTime = new Date(t1.end);
    },
    //时间改变下拉控件要改变
    datePickerChange() {
      this.day = 200;
      var that = this;
      //开始时间小于结束时间
      this.endDateOptions = {
        disabledDate(date) {
          var start = that.$store.state.startEndTime[0].getTime();
          //return date && date.valueOf() < Date.now() - 86400000;
          return date && date.valueOf() < start + 1000 - 86400000;
        },
      };
    },
    //打开选择器
    openPicker(t) {
      if (t == 0) {
        this.$refs.picker0.open();
      } else {
        this.$refs.picker1.open();
      }
    },
    //点击时间控件，修改开始时间
    handleConfirm(x) {
      this.ss = new Date(x.getTime());
    },
    //时间转换
    myday(t) {
      const d = new Date(t);
      var m = d.getMonth() + 1;
      return (
        d.getFullYear() +
        "-" +
        m +
        "-" +
        d.getDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds()
      );
    },
    //获取系统时间 年月日
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    //配合上GetDay函数使用的
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    reCar(v) {
      this.openSelectCar = false;
      (this.$store.state.carMsg.deviceId = v.deviceId),
        (this.$store.state.carMsg.carNo = v.carNo);
    },
  },
  mounted() {
    this.selectGetDay(0);
  },
};
</script>
<style lang="">
#select_wrap {
  background: white;
  padding: 0;
  text-align: left;
  position: relative;
}
#select_wrap .show {
  margin-bottom: 20px;
  position: absolute;
  right: 8px;
  top: 2px;
}
#select_wrap .ivu-row {
  margin-bottom: 20px;
}
#select_wrap .input {
  width: 100%;
  border: solid 1px #ddd;
  padding: 4px 10px;
  height: 30px;
  border-radius: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/select.vue